import { FileManagerTypes } from "./fileManagerTypes";

export const fileManagerReducer = {
  resetFileMangerFetching: (state: FileManagerTypes) => {
    state.fetching = false;
  },
  resetFileManagerError: (state: FileManagerTypes) => {
    state.error = null;
  },
  resetFileManagerSuccess: (state: FileManagerTypes) => {
    state.success = null;
  },
  resetFileManagerUploadSuccess: (state: FileManagerTypes) => {
    state.uploadSuccess = null;
  },
  resetFileManagerStatusCode: (state: FileManagerTypes) => {
    state.statusCode = null;
  },
  resetChildFoldersList: (state: FileManagerTypes) => {
    state.childFolders = [];
  },
  resetChildFilesList: (state: FileManagerTypes) => {
    state.childFiles = [];
  },
  resetCurrentDirPath: (state: FileManagerTypes) => {
    state.currentDirPath = [];
  },
  resetUploadFileData: (state: FileManagerTypes) => {
    state.uploadFileData = {};
  },
  resetTotalCount: (state: FileManagerTypes) => {
    state.totalCount = 0;
  },
};
